import React, { useState, useEffect } from 'react';
import MembershipListServices from '../../services/MembershipListServices';
import MembershipServiceListServices from '../../services/MembershipServiceListServices';
import MembershipCategoryServices from '../../services/MembershipCategoryServices';
import CategoryServices from '../../services/CategoryServices';
import SubCategoryServices from '../../services/SubCategoryServices';
import HomesliderServices from '../../services/HomeSliderServices';
import WebSliderServices from '../../services/WebSliderServices';
import WebAvertiesmentServices from '../../services/WebAdvertimentServices';

const HelpTogal = ({ help, page, onSuccess }) => {

  // ✅ function for initial state
  const getInitialChecked = () => {
    if (page === 'MembershipService') {
      return help?.isActive;
    }
    if (page === 'Membership') {
      return help?.status === 'Active';
    }
    if (page === 'MembershipCategory') {
      return help?.status === 'Active';
    }
    return help?.status === 'show';
  };

  const [isChecked, setIsChecked] = useState(getInitialChecked());

  // ✅ sync when data changes
  useEffect(() => {
    setIsChecked(getInitialChecked());
  }, [help, page]);

  const handleToggle = async () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked); // optimistic update

    try {
      let payload;
      let apiCall;

      switch (page) {
        case 'MembershipService':
          payload = { isActive: newChecked };
          apiCall = MembershipServiceListServices.statusUpdateMembershipService;
          break;

        case 'Membership':
          payload = { status: newChecked ? 'Active' : 'Inactive' };
          apiCall = MembershipListServices.updateMembership;
          break;

        case 'MembershipCategory':
          payload = { status: newChecked ? 'Active' : 'Inactive' };
          apiCall = MembershipCategoryServices.membershipCategoryStatusUpdate;
          break;

        case 'Category':
          payload = { status: newChecked ? 'show' : 'hide' };
          apiCall = CategoryServices.updateCategory;
          break;

        case 'subcategory':
          payload = { status: newChecked ? 'show' : 'hide' };
          apiCall = SubCategoryServices.updateCategory;
          break;

        case 'HomeSlider':
          payload = { status: newChecked ? 'show' : 'hide' };
          apiCall = HomesliderServices.updateHomeSlider;
          break;

        case 'WebSlider':
          payload = { status: newChecked ? 'show' : 'hide' };
          apiCall = WebSliderServices.updateWebSlider;
          break;
        case 'WebAdvertisement':
          payload = { status: newChecked ? 'show' : 'hide' };
          apiCall = WebAvertiesmentServices.updateWebSlider;
          break;

        case 'Banner':
          payload = { status: newChecked ? 'show' : 'hide' };
          apiCall = HomesliderServices.updateBanner;
          break;

        default:
          return;
      }

      await apiCall(help._id, payload);
      onSuccess && onSuccess();

    } catch (error) {
      console.log("Status Update Error:", error);

      // ❌ rollback if API fails
      setIsChecked(!newChecked);
    }
  };

  return (
    <div className="check-box">
      <input
        type="checkbox"
        checked={!!isChecked}
        onChange={handleToggle}
      />
    </div>
  );
};

export default HelpTogal;